<!--<app-sidebar *ngIf="!this.evaluationId">-->
<!--    <app-ask-for-id-dialog (EvaluationId)="receiveEvaluationId($event)"></app-ask-for-id-dialog>-->
<!--</app-sidebar>-->
<app-sidebar *ngIf="this.evaluationId">
    <app-result-test>
<!--                     [evaluationId]="evaluationId"-->
    </app-result-test>
</app-sidebar>
